<template>
  <div v-if="$admin.can('ROLE_ADMIN')">
    <h1>Batch Rest</h1>
    <v-alert color="error">Currently only working for budgets. Will update <b>scope</b> to <b>order</b></v-alert>
    <v-text-field label="Endpoint" v-model="endpoint" />
    <v-textarea label="Codes" v-model="codes" placeholder="Enter Codes, one for every row" />
    <v-checkbox v-model="dryRun" label="Dry Run" />
    <v-btn @click="update" :disabled="codesArray.length === 0" :loading="isRunning">Run</v-btn>
    <v-btn @click="abortRun" v-if="isRunning">Abort</v-btn>
    <div>
      <h2>Result</h2>
      <v-progress-linear height="30" v-model="currentPercent">{{ currentIndex }} / {{ codesArray.length }}</v-progress-linear>
      <ul style="overflow: auto">
        <li v-for="(element, index) in result" :key="index">
          <pre>{{ element }}</pre>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import admin from "@/plugins/admin.js";

export default {
  data() {
    return {
      codes: "",
      endpoint: "/budgets",
      result: [],
      isRunning: false,
      currentIndex: 0,
      abort: false,
      dryRun: false
    };
  },
  methods: {
    abortRun() {
      this.abort = true;
    },
    async update() {
      this.result = [];
      this.isRunning = true;
      this.currentIndex = 0;
      try {
        for (const code of this.codesArray) {
          if (this.abort === true) {
            break;
          }
          const response = await admin.http.get(`${this.endpoint}?q=~${code}`);
          if (response.data.metadata.total === 0) {
            this.result.push(`${code} not found - skip`);
            this.currentIndex++;
            continue;
          }
          const foundBudgets = response.data.data;

          let found = false;
          for (const budget of foundBudgets) {
            if (budget.code !== code) {
              continue;
            }
            found = true;
            budget.issuer = null;
            const internalId = budget.id;

            let urlWithId = `${this.endpoint}/${internalId}`;
            if (this.dryRun) {
              this.result.push(`${code} will be updated with ${urlWithId} and payload ${JSON.stringify(budget)})`);
            } else {
              await admin.http.put(urlWithId, budget);
              this.result.push(`${code} updated (internalId: ${internalId})`);
            }
            this.currentIndex++;
          }
          if (!found) {
            this.result.push(`${code} not found - skip`);
            this.currentIndex++;
          }
        }
      } finally {
        this.isRunning = false;
      }
    }
  },
  computed: {
    codesArray() {
      if (this.codes.length === 0) {
        return [];
      }
      return this.codes.split("\n").filter(element => element.length > 0);
    },
    currentPercent() {
      if (this.codesArray.length === 0) {
        return 0;
      }
      return (this.currentIndex / this.codesArray.length) * 100;
    }
  }
};
</script>
